import { PermissionsEnum } from "@/auth/interfaces";
import { EstadosProcesoEnumChoice, gridSize,  newUpdateOrdenCompraSchema, ROUTER_PATHS, useCheckPermissions } from "@/shared";
import { LoaderComponent, SingleTableBoxScene } from "@/shared/components/ui";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import BlockIcon from '@mui/icons-material/Block';
import {  Grid, TextField, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useTableOrdeneCompra from "../../shared/hook/useTableOrdenCompra";
import { useGetOrdenesCompra, useUpdateOrdenesCompra } from "@/shared/actions/erp";
import { useUiStore } from "@/store/ui";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { useEffect, useState } from "react";
import CustomCircularProgress from "@/shared/components/ui/Loaders/CustomCircularProgress";
import PersonIcon from '@mui/icons-material/Person';
import Person3Icon from '@mui/icons-material/Person3';
import ShowNamesUser from "@/shared/components/ui/ShowNamesUser/showNamesUser";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

export type UpdateOrdenCompra = {
  observaciones: {
    observacionCerrarOrden: string;
  }
}

const FinalizarOrdenesCompraAbierto = () => {
  useCheckPermissions(PermissionsEnum.api_view_ordencompra)
  useCheckPermissions(PermissionsEnum.api_change_ordencompra)
  const navigate = useNavigate()
  const { id } = useParams()
  /***state */
  const [isLoadingProgress, setIsLoadingProgress] = useState(false)
  /*   console.log('id', id) */
  //**store */
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const paginationTable = useCargarSeriesProductos(s => s.pagination)
  const setPaginationTable = useCargarSeriesProductos(s => s.setPagination)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const setAlert = useUiStore(s => s.setAlert)
  //console.log('productos', productos)
  //const handleAgregarUrlSerie = useCargarSeriesProductos(s => s.handleAgregarUrlSerie)
  ///hook
  const { detallesProductos } = useTableOrdeneCompra()
  ///FETCH
  const { data: ordenCompra, isLoading } = useGetOrdenesCompra(id!)
  const updateOrdenesCompra = useUpdateOrdenesCompra({})
  ///const createIngresoInventario = useCreateIngresoProducto()
  //form
  const form = useForm<UpdateOrdenCompra>({
    resolver: yupResolver(newUpdateOrdenCompraSchema)
  })
  const { /* control */ handleSubmit, formState: { errors } } = form
  //
  useEffect(() => {
    if (productos.length !== 0) return;
    navigate(ROUTER_PATHS.compras.orden_compras_nav, { state: { tabIndex: 2 } })
  }, [productos]);

  ///***********mutation update
  const onUpdateCerrarOrden = () => {

    setConfirmDialogIsOpen(true)
    setConfirmDialog({
      isOpen: true,
      title: 'Cerrar orden de compra',
      subtitle: "Esta acción es irreversible. Una vez cerrada, no podrás modificar la orden de compra. ¿Estás seguro de que deseas continuar?",
      onClose() {
        setConfirmDialogIsOpen(false)
      },
      onConfirm: async () => {
        setConfirmDialogIsOpen(false)
        setIsLoadingProgress(true)
        const observacionesActuales = ordenCompra?.data.observaciones || {}
        const cerrarOrden: any = {
          id: id,
          data: {
            estado_orden: EstadosProcesoEnumChoice.FINALIZADO,
            observaciones: {
              ...observacionesActuales,
              observacionCerrarOrden: form.getValues().observaciones?.observacionCerrarOrden
            }
          }
        }
        //ingreso-Inventario
        /*  const producto = productos?.map((elementos) => ({
           ...elementos,
           series:[],
           cantidad: '0'
         }))
         const ingresoInventario: any = {
           solicitud_ingreso: ordenCompra?.data.solicitud_ingreso,
           ordenCompra: ordenCompra?.data.codigo!,
           productos: producto
         }
         console.log('ingrseoInventario', ingresoInventario) */
        try {

          /* const respIngrseoInventario = await createIngresoInventario.mutateAsync(ingresoInventario)
          if (respIngrseoInventario.code !== 200) return; */

          const respCerrarOrden = await updateOrdenesCompra.mutateAsync(cerrarOrden)
          if (respCerrarOrden.code !== 200) return;
          navigate(ROUTER_PATHS.compras.orden_compras_nav, { state: { tabIndex: 2 } })
          clearSelectedItems()
        } catch (error) {
          console.log("Error en la mutación", error)
        } finally {
          setIsLoadingProgress(false)
        }

      },
    })
  }



  if (isLoading) return <LoaderComponent />


  return (
    <>
      <SingleTableBoxScene
        title="Gestión de Cierre de Órdenes de Pedido"
        enableBackBtn={false}
        backPageUrl={ROUTER_PATHS.compras.orden_compras_nav}
        visibleReport={false}
        //cerar orden
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Cerrar Orden "
        iconCreateOrEdit={<BlockIcon />}
        fnCreateOrEdit={handleSubmit(onUpdateCerrarOrden,
          () => { setAlert(true, 'Es obligatorio la observación.', AlertSeverityEnum.error) }
        )}
        ///cancelar 
        enableAccionBtn={true}
        labelTextActionBtn="Cancelar"
        fnAccionBtn={() => {
          navigate(ROUTER_PATHS.compras.orden_compras_nav, { state: { tabIndex: 2 } })
        }}
      >
        <>
          <Grid container spacing={2}>
            <Grid item>
              <Typography variant="subtitle2" color={"text.secondary"} fontWeight={'600'}>{'INFORMACIÓN'}</Typography>

            </Grid>
            <Grid item {...gridSize}>
              <Grid container spacing={4}>

                <Grid item>
                  <ShowNamesUser
                    title="Solicitud-Compra"
                    icon={<PersonIcon color="info" sx={{ fontSize: 25 }} />}
                    user={ordenCompra?.data?.solicitud_ingreso_data?.user || 'N/A'}
                  />

                </Grid>

                <Grid item>

                  <ShowNamesUser
                    title="Orden-Pedido"
                    icon={<Person3Icon color="info" sx={{ fontSize: 25 }} />}
                    user={ordenCompra?.data?.user_create || 'N/A'}
                  />

                </Grid>
                {ordenCompra?.data?.ingreso_inventario_data?.at(-1)?.numero_factura?.trim() && (
                  <Grid item>
                    <ShowNamesUser
                      title="Último Factura ingresada"
                      icon={<ReceiptLongIcon color="info" sx={{ fontSize: 25 }} />}
                      user={
                        ordenCompra?.data?.ingreso_inventario_data?.at(-1)?.numero_factura?.trim() ||
                        //ordenCompra?.data.ingreso_inventario_data?.at(-1)?.numero_guia_remision ||
                        'N/A'
                      }
                      texto={'#'}
                    />
                  </Grid>
                )}
                {ordenCompra?.data?.ingreso_inventario_data?.at(-1)?.numero_guia_remision?.trim() && (
                  <Grid item>
                    <ShowNamesUser
                      title="Último Remisión Ingresada"
                      icon={<ReceiptLongIcon color="info" sx={{ fontSize: 25 }} />}
                      user={
                        //ordenCompra?.data?.ingreso_inventario_data?.at(-1)?.numero_factura?.trim() ||
                        ordenCompra?.data?.ingreso_inventario_data?.at(-1)?.numero_guia_remision ||
                        'N/A'
                      }
                      texto={'#'}
                    />

                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <TextField
                {...form.register("observaciones.observacionCerrarOrden")}

                variant="outlined"
                label="Observación *"
                multiline
                rows={2}
                fullWidth
                error={!!errors.observaciones?.observacionCerrarOrden}
                helperText={errors.observaciones?.observacionCerrarOrden?.message}
              />
            </Grid>
            
            {/* <Grid item {...gridSize}>
              <Grid container spacing={1}>
                <Grid item {...gridSize} spacing={2} container justifyContent={'flex-end'}>
                  <Grid item {...gridSizeMdLg3}>
                    <CustomAutocomplete
                      label="Seleccione"
                      name="url_pdf"
                      options={[]}
                      isLoadingData={false}
                      valueKey={"reporte_nombre"}
                      actualValueKey={"url_pdf"}
                      defaultValue={undefined}
                      control={control}
                      error={undefined}
                      helperText={undefined}
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      startIcon={<DownloadForOfflineIcon />}
                    >
                      {'DESCARGAR'}

                    </Button>

                  </Grid>

                </Grid>

              </Grid>

            </Grid> */}

            <Grid item xs={12}>

              <SampleTablePagination
                columns={detallesProductos}
                data={paginatedData}
                rowCount={productos.length}
                pagination={paginationTable}
                setPagination={setPaginationTable}
              />
            </Grid>



          </Grid>
        </>
      </SingleTableBoxScene>
      <CustomCircularProgress
        open={isLoadingProgress}
        message="Cerrando el orden, un momento"
        progressColor="inherit"
        thickness={4}
        puntoAnimado={true}
      />
    </>
  )
}
export default FinalizarOrdenesCompraAbierto;